import React from "react";

type MaximiseFullIconProps = {
  color?: string;
  size?: "small";
};

const MaximiseFullIcon = (props: MaximiseFullIconProps) => {
  const { color, size } = props;

  if (size === "small") {
    return (
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.5 5L13.5 1M13.5 1H10.5909M13.5 1V3.90909M5.5 9L1.5 13M1.5 13H4.40909M1.5 13L1.5 10.0909M5.5 5L1.5 1M1.5 1L1.5 3.90909M1.5 1L4.40909 1M9.5 9L13.5 13M13.5 13V10.0909M13.5 13H10.5909"
          stroke={color || "#195FE9"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L18.4697 19.5303ZM13 13V12.25C12.5858 12.25 12.25 12.5858 12.25 13H13ZM12.25 17.3636C12.25 17.7778 12.5858 18.1136 13 18.1136C13.4142 18.1136 13.75 17.7778 13.75 17.3636H12.25ZM17.3636 13.75C17.7778 13.75 18.1136 13.4142 18.1136 13C18.1136 12.5858 17.7778 12.25 17.3636 12.25V13.75ZM0.46967 18.4697C0.176777 18.7626 0.176777 19.2374 0.46967 19.5303C0.762563 19.8232 1.23744 19.8232 1.53033 19.5303L0.46967 18.4697ZM7 13H7.75C7.75 12.5858 7.41422 12.25 7 12.25V13ZM2.63636 12.25C2.22215 12.25 1.88636 12.5858 1.88636 13C1.88636 13.4142 2.22215 13.75 2.63636 13.75L2.63636 12.25ZM6.25 17.3636C6.25 17.7779 6.58579 18.1136 7 18.1136C7.41421 18.1136 7.75 17.7779 7.75 17.3636H6.25ZM19.5303 1.53033C19.8232 1.23744 19.8232 0.762564 19.5303 0.46967C19.2374 0.176777 18.7626 0.176777 18.4697 0.46967L19.5303 1.53033ZM13 7H12.25C12.25 7.41421 12.5858 7.75 13 7.75V7ZM17.3636 7.75C17.7778 7.75 18.1136 7.41421 18.1136 7C18.1136 6.58579 17.7778 6.25 17.3636 6.25V7.75ZM13.75 2.63636C13.75 2.22215 13.4142 1.88636 13 1.88636C12.5858 1.88636 12.25 2.22215 12.25 2.63636H13.75ZM1.53033 0.46967C1.23744 0.176777 0.762563 0.176777 0.46967 0.46967C0.176777 0.762563 0.176777 1.23744 0.46967 1.53033L1.53033 0.46967ZM7 7V7.75C7.41421 7.75 7.75 7.41421 7.75 7H7ZM7.75 2.63636C7.75 2.22215 7.41421 1.88636 7 1.88636C6.58579 1.88636 6.25 2.22215 6.25 2.63636L7.75 2.63636ZM2.63636 6.25C2.22215 6.25 1.88636 6.58579 1.88636 7C1.88636 7.41421 2.22215 7.75 2.63636 7.75L2.63636 6.25ZM19.5303 18.4697L13.5303 12.4697L12.4697 13.5303L18.4697 19.5303L19.5303 18.4697ZM13.75 17.3636L13.75 13H12.25L12.25 17.3636H13.75ZM13 13.75H17.3636V12.25H13V13.75ZM1.53033 19.5303L7.53033 13.5303L6.46967 12.4697L0.46967 18.4697L1.53033 19.5303ZM2.63636 13.75L7 13.75V12.25L2.63636 12.25L2.63636 13.75ZM6.25 13L6.25 17.3636H7.75L7.75 13H6.25ZM18.4697 0.46967L12.4697 6.46967L13.5303 7.53033L19.5303 1.53033L18.4697 0.46967ZM17.3636 6.25L13 6.25V7.75L17.3636 7.75V6.25ZM13.75 7V2.63636H12.25V7H13.75ZM0.46967 1.53033L6.46967 7.53033L7.53033 6.46967L1.53033 0.46967L0.46967 1.53033ZM6.25 2.63636L6.25 7H7.75L7.75 2.63636L6.25 2.63636ZM7 6.25L2.63636 6.25L2.63636 7.75L7 7.75V6.25Z"
        fill={color || "#999999"}
      />
    </svg>
  );
};

export default MaximiseFullIcon;
